<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading"
  >
    <!-- <div slot="header">
      <span>Балансы</span>
    </div> -->
    <div v-if="ledgerValutes.docs">
      <el-table
        :data="ledgerValutes.docs"
        @sort-change="handleSortChange"
        :default-sort="{ prop: '_id', order: 'descending' }"
        :row-class-name="tableRowClassName"
        border
        stripe
      >
        <el-table-column sortable="custom" prop="_id" label="ID" width="90">
          <template slot-scope="scope">
            <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
            {{ scope.row._id.slice(-6) }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="name" label="Название">
        </el-table-column>
        <el-table-column prop="additionalKeys" label="Доп. ключи" width="180">
          <template slot-scope="scope">
            <span
              style="padding-right: 0.5em;"
              v-for="k in scope.row.additionalKeys"
              >{{ k }}</span
            >
            <span>
              <el-button
                icon="el-icon-edit"
                circle
                size="mini"
                @click="handleOpenAddKeysDialog(scope.row)"
              ></el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="type" label="Тип" width="180">
          <template slot-scope="scope">
            {{ types[scope.row.type] || scope.row.type }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="session.type <= -1"
          fixed="right"
          label="Действия"
          width="150"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">Удалить валюту</div>
              <el-button
                size="small"
                icon="el-icon-delete"
                @click="handleDeleteValute(scope.row._id)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleValutesPage"
        :current-page.sync="ledgerValutes.page"
        :page-size="ledgerValutes.limit"
        layout="prev, pager, next, jumper"
        :total="ledgerValutes.totalDocs"
      >
      </el-pagination>
    </div>
    <el-collapse>
      <el-collapse-item name="1">
        <template slot="title">
          <i class="header-icon el-icon-plus"></i>
          Добавить валюту
        </template>
        <el-form
          :model="newValute"
          ref="form"
          label-width="180px"
          :inline="false"
          size="normal"
        >
          <el-form-item label="Тип">
            <el-select v-model="newValute.type" filterable>
              <el-option key="crypto" label="Криптовалюта" value="crypto">
              </el-option>
              <el-option key="fiat" label="Фиат" value="fiat"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Название">
            <el-input v-model="newValute.name"></el-input>
          </el-form-item>
          <el-form-item label="Дополнительные ключи валют">
            <el-select
              v-model="newValute.additionalKeys"
              clearable
              filterable
              multiple
            >
              <el-option
                v-for="item in mainValutesKeys"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addValute">Добавить</el-button>
            <el-button @click="resetNewValute">Очистить</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      :title="`Дополнительные ключи для ${editingValute.name}`"
      :visible.sync="addKeyDialogVisible"
    >
      <el-form :model="addKeyForm">
        <el-form-item label="Дополнительные ключи валют">
          <el-select
            v-model="addKeyForm.additionalKeys"
            clearable
            filterable
            multiple
          >
            <el-option
              v-for="item in mainValutesKeys"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.prevent="addKeyDialogVisible = false"
          >Отменить</el-button
        >
        <el-button type="primary" @click.prevent="handleAddKey"
          >Сохранить</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getLedgerTransactions, getValutes } from "@/api";
export default {
  name: "LedgerValutesComponent",
  data: () => ({
    newValute: {
      type: null,
      name: "",
      additionalKeys: []
    },
    types: {
      crypto: "Криптовалюта",
      fiat: "Фиат"
    },
    mainValutesKeys: [],
    addKeyDialogVisible: false,
    addKeyForm: {
      additionalKeys: []
    },
    editingValute: {}
  }),
  computed: {
    ...mapState("ledgerValutes", ["ledgerValutes", "loading"]),
    ...mapState("auth", ["session"])
  },
  methods: {
    ...mapActions("ledgerValutes", [
      "getLedgerValutes",
      "goToPage",
      "changeSorting",
      "addLedgerValute",
      "deleteLedgerValute",
      "editLedgerValute"
    ]),
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    handleOpenAddKeysDialog(valute) {
      this.editingValute = { ...valute };
      this.addKeyForm.additionalKeys = [...valute.additionalKeys];
      this.addKeyDialogVisible = true;
    },
    async handleAddKey() {
      try {
        await this.editLedgerValute({
          id: this.editingValute._id,
          ledgerValute: {
            ...this.editingValute,
            ...this.addKeyForm
          }
        });
        this.$notify({
          title: "Успех",
          message: "Дополнительные ключи были сохранены!",
          type: "success"
        });
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.addKeyDialogVisible = false;
      }
    },
    async handleDeleteValute(id) {
      // const linkedTransactions = await getLedgerTransactions({
      //   pagination: false,
      //   query: { balanceAccount: id }
      // });
      // console.log(linkedTransactions);
      let message = "Вы точно хотите удалить валюту?";
      // if (
      //   linkedTransactions.data.status &&
      //   linkedTransactions.data.result.totalDocs
      // )
      //   message += " У баланса есть связанные транзакции!";

      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await this.deleteLedgerValute(id);
        this.$message({
          type: "success",
          message: `Валюта успешно удалена`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.changeSorting({ sort });
    },
    handleValutesPage(page) {
      this.goToPage({ page });
    },
    resetNewValute() {
      this.newValute = {
        type: null,
        name: ""
      };
    },
    async addValute() {
      try {
        const data = {
          ...this.newValute
        };
        const resp = await this.addLedgerValute(data);
        // console.log(resp);
        this.resetNewValute();
        return this.$notify.success({
          title: "Успех",
          message: `Валюта ${resp.data.result.name || ""} создана!`
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    }
  },
  async mounted() {
    await this.getLedgerValutes();
    const { data } = await getValutes();
    if (data.status)
      this.mainValutesKeys = Array.from(new Set(data.result.map(v => v.key)));
  }
};
</script>
<style>
/* .el-table .new-row {
  animation-duration: 1s;
  animation-name: blinknewrow;
  animation-iteration-count: 1;
}
@keyframes blinknewrow {
  from {
    background-color: transparent;
  }
  50% {
    background-color: pink;
  }
  to {
    background-color: transparent;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/valutes.vue